import { storyblokEditable } from "@storyblok/react";
import { customRenderRichText } from "../utils/renderRichText";

// Link resolver
const resolveStoryblokLink = (link) => {
  if (!link) return "#";

  // Internal Storyblok story links
  if (link.linktype === "story") {
    const slug = link.cached_url || link.story?.full_slug;
    return slug ? `/${slug}` : "#";
  }

  // Asset links if they are needed like a PDF
  if (link.linktype === "asset") {
    return link.url || "#";
  }

  // URLs
  return link.url || link.cached_url || "#";
};

const ContactBanner = ({ blok }) => {
  const backgroundImage = blok.background_image?.filename || "";
  const buttonIcon = blok.button_icon?.filename || "";

  const buttonHref = resolveStoryblokLink(blok.button_link);

  return (
    <section
      {...storyblokEditable(blok)}
      className="flex flex-col items-center justify-center text-center w-full h-[350px] bg-cover bg-center px-4"
      style={{
        backgroundImage: `url(${backgroundImage})`,
      }}
    >
      {/* Title */}
      <h2
        className="text-white"
        style={{
          fontSize: "32px",
          fontWeight: 500,
        }}
      >
        {blok.title}
      </h2>

      {/* Body */}
      {blok.body && (
        <div
          className="text-white mt-3 max-w-[600px]"
          style={{ fontSize: "16px", fontWeight: 400 }}
        >
          {typeof blok.body === "string"
            ? blok.body
            : customRenderRichText(blok.body)}
        </div>
      )}

      {/* Button */}
      <a
        href={buttonHref}
        className="mt-6 flex items-center justify-center text-white rounded-full gap-2"
        style={{
          width: "162px",
          height: "34px",
          backgroundColor: "#1371DC",
          fontSize: "14px",
          fontWeight: 500,
        }}
      >
        {buttonIcon && (
          <img
            src={buttonIcon}
            alt=""
            width={19}
            height={14}
            className="object-contain"
          />
        )}

        {blok.button_text}
      </a>
    </section>
  );
};

export default ContactBanner;
